import { render, staticRenderFns } from "./IllegalList.vue?vue&type=template&id=4f033c0c&scoped=true&"
import script from "./IllegalList.vue?vue&type=script&lang=ts&"
export * from "./IllegalList.vue?vue&type=script&lang=ts&"
import style0 from "./IllegalList.vue?vue&type=style&index=0&id=4f033c0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f033c0c",
  null
  
)

export default component.exports